import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useUserProfile } from '../../../hooks/useUserProfile';
import { Button, Col, Form, notification, Row } from 'antd';
import ApiService from '../../../services/ApiService';
import { isEmpty } from 'lodash';

const ChangeUserPassword = () => {
  const { userProfile } = useUserProfile();
  const [loading, setLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    getValues,
  } = useForm({});

  useEffect(() => {
    api.info({
        message: 'Verification Code Sent',
        description: `Verification code has been sent to ${userProfile?.email}`
    })
    return () => reset();
  }, []);

  const handleChangePasswordSubmit = async (data) => {
    if (!data || isEmpty(data)) return;
    try {
      setLoading(true);
      await ApiService.forgetPasswordSubmit({
        email: userProfile?.email,
        ...data,
      });
      setLoading(false);
      api.success({
        message: 'Success',
        description: 'Password changed successfully!',
        showProgress: false,
      });
    } catch (error) {
      setLoading(false);
      error?.message &&
        api.error({
          message: 'Error',
          description: error?.message,
          showProgress: false,
        });
    }
  };

  return (
    <>
      {contextHolder}
      <form onSubmit={handleSubmit(handleChangePasswordSubmit)}>
        <Col sm={24} md={12}>
          <Row gutter={[16, 16]} align={'bottom'}>
            <Col md={24}>
              <div className="form-group">
                <label>
                  Code <span className="login-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  {...register('code', { required: true })}
                />
                <small style={{ color: 'red', height: '32px' }}>
                  <p>{errors.code ? 'Please enter the code' : ''}</p>
                </small>
              </div>
            </Col>
            <Col md={24}>
              <div className="form-group">
                <label>
                  New Password <span className="login-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  {...register('password', { required: true })}
                />
                <small style={{ color: 'red', height: '32px' }}>
                  <p>{errors.password ? 'Please enter new password' : ''}</p>
                </small>
              </div>
            </Col>
            <Col md={24}>
              <div className="form-group">
                <label>
                  Comfirm Password <span className="login-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  {...register('confirmPassword', {
                    required: 'Please Enter Confirm Password',
                    validate: (match) => {
                      const password = getValues('password');
                      return match === password || 'Passwords should match!';
                    },
                  })}
                />
                <small style={{ color: 'red', height: '32px' }}>
                  <p>{errors.confirmPassword?.message}</p>
                </small>
              </div>
            </Col>
            <Col md={24}>
              <Form.Item>
                <Button
                  key="ok"
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  shape="round"
                  size="large"
                >
                  Change Password
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </form>
    </>
  );
};

export default ChangeUserPassword;
